export default __webpack_public_path__ + "static/media/calconvert_s1.537e4e7c.png";